import React from 'react'
import { DigitalContractTemplatesView } from "../../views";
import { TemplateService, LocalStorageService } from '../../../services/index'

class DigitalContractTemplateAction extends React.Component {
    constructor(props) {
        super(props)
        this.props = props
        this.state = {
            clientTemplates: [],
            formatVariables: [],
            onNewTemplate: false,
            onEdit: false,

            loading: false,
            shouldRefresh: false,
            token: '',
            companies: [],
            showLoadingRequesting: false,
            showCompletedRequesting: false,
            showErrorRequesting: false,
            message: '',
            clientId: 0
        }
    }


    token = {};
    url = process.env.REACT_APP_MIFIRMA_API;
    templateService = new TemplateService(this.url);
    localStorageService = new LocalStorageService();


    async componentDidMount() {
        this.setState({ loading: true });
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user")
        let clientId = this.user.userMetaData.userA3Cloud.clientId

        try {
            let templates = await this.templateService.getTemplatebyClientId(clientId, null, this.token);
            let company = await this.templateService.getCompanies(this.token);

            let formatsVariable = await this.templateService.getFormatVariables(this.token)
            let companies = [{
                "id": "00000000-0000-0000-0000-000000000000",
                "companyName": this.props.t("questionnairesAssignCategories.no.assign"),
                "businessName": this.props.t("questionnairesAssignCategories.no.assign"),
                "typeOfCompany": "",
                "status": true,
                "logo": "",
                "rfc": "",
                "addressStreet": "",
                "addressTownship": "",
                "addressState": "",
                "addressCountry": "",
                "addressZipCode": "",
                "turnOfTheCompany": "",
                "description": "",
                "deactivationReason": "",
                "updatedByUser": ""
            }, {
                "id": "1",
                "companyName": this.props.t("digitalContractAction.routes.standar.contracts"),
                "businessName": this.props.t("digitalContractAction.routes.standar.contracts"),
                "typeOfCompany": "",
                "status": true,
                "logo": "",
                "rfc": "",
                "addressStreet": "",
                "addressTownship": "",
                "addressState": "",
                "addressCountry": "",
                "addressZipCode": "",
                "turnOfTheCompany": "",
                "description": "",
                "deactivationReason": "",
                "updatedByUser": ""
            }]

            company.sort((a, b) => a.company.companyName.localeCompare(b.company.companyName));
            company.map((company) => {
                if (company.company.status === true) {
                    companies.push(company.company)
                }
                return company
            });
            this.setState({
                loading: false,
                clientTemplates: templates,
                token: this.token,
                companies: companies,
                clientId: clientId,
                formatVariables: formatsVariable
            })

        } catch {
            this.props.history.push("/");
            return;
        }

    }


    async componentDidUpdate(prevProps, prevState) {
        if (prevState.shouldRefresh !== this.state.shouldRefresh) {
            this.getUserCollaboratorsAdmin();
        }
    }


    async getTemplatebyPath(documentPath) {
        let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);
        let localStorageService = new LocalStorageService()

        let token = localStorageService.getLocalStorageItem('token').idToken
        let response = await templateService.getTemplatebyDocumentPath(documentPath, token);

        return response
    }

    async getVariablesFromDocument(document) {
        let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);
        let localStorageService = new LocalStorageService()
        let data = new FormData()
        data.append('doc', document)

        let token = localStorageService.getLocalStorageItem('token').idToken
        let response = await templateService.getVariablesFromDocument(data, token);

        return response
    }

    forceRefresh = () => {
        this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
    };

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value, message, templates) => {
        this.setState(
            {
                showCompletedRequesting: value,
                message: message
            },
            () => {
                setTimeout(() => {
                    this.setState({
                        showCompletedRequesting: false,
                        message: '',
                        clientTemplates: templates,

                    });
                    // funcion()
                }, 4000);
            }
        );
    };

    toggleErrorRequesting = (value, message) => {
        this.setState(
            {
                showErrorRequesting: value,
                message: message
            },
            () => {
                setTimeout(() => {
                    this.setState({
                        showErrorRequesting: false,
                        message: ''
                    });
                }, 4000);
            }
        );
    };


    render() {
        return (
            <DigitalContractTemplatesView
                {...this.state}
                forceRefresh={this.forceRefresh}
                getVariablesFromDoc={this.getVariablesFromDocument}
                getTemplatebyPath={this.getTemplatebyPath}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                history={this.props.history}
                changeRoute={this.props.changeRoute}
            />
        )
    }
}
export { DigitalContractTemplateAction as default }